const pad = (number: number) => (`0${number}`).substr(-2)

export const formatDate = (date: Date): string => {
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`
}
